/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListAssetsOptions, ListAssetsResponses } from '../types/ListAssets'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List assets
 * {@link /v1/assets}
 */
export function listAssets<ThrowOnError extends boolean = true>(
  options: Options<ListAssetsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListAssetsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/assets',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListAssetsResponses, ThrowOnError>>,
  )
}
